var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.2 31.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m14.5 2.7c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "M14,2.2h-0.5c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2H14c0.1,0,0.2-0.1,0.2-0.2S14.1,2.2,14,2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m14.5 1.3c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "M15.5,2.2H15c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2h0.5c0.1,0,0.2-0.1,0.2-0.2S15.6,2.2,15.5,2.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m35.6 26.4c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.3s0.3-0.2 0.3-0.3v-0.8c0.1-0.1-0.1-0.3-0.3-0.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "M34.8,25.6H34c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h0.8c0.2,0,0.3-0.1,0.3-0.3S35,25.6,34.8,25.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m35.6 23.9c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.3s0.3-0.2 0.3-0.3v-0.8c0.1-0.1-0.1-0.3-0.3-0.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m37.3 25.6h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.2 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3s-0.1-0.3-0.3-0.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m2 18.7s0.3 1.9-2 1.9c0 0 2 0 1.9 1.8 0 0 0.2-1.4 2-1.8 0 0.1-1.5 0.5-1.9-1.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m33.2 5.4s0.3 1.9-2 1.9c0 0 2 0 1.9 1.8 0 0 0.2-1.4 2-1.8 0 0.1-1.5 0.5-1.9-1.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m5 30s0.1 1.1-1.1 1.1c0 0 1 0 1 1 0 0 0.1-0.8 1.1-1 0 0-0.8 0.2-1-1.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m6 10.6s0.1 0.6-0.6 0.6c0 0 0.6 0 0.6 0.6 0 0 0.1-0.5 0.6-0.6 0.1 0.1-0.4 0.2-0.6-0.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "emailGreenCheckBkgHK",
    d: "m16.8 17.1c0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9c0-0.8-0.3-1.5-0.9-2.1-0.5-0.5-1.3-0.9-2.1-0.8-1.5 0-2.8 1.3-2.8 2.9zm2.8 1.5-1.2-1.3 0.4-0.4 0.8 0.8 1.3-2 0.4 0.3s-1.7 2.6-1.7 2.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m14 8.6c-0.3 0.3-0.5 0.7-0.4 1.1v11.5l1.8 1.5c-0.2-0.4-0.3-0.9-0.3-1.4v-10.5c0-1 0.4-1.9 1-2.6h-1.1c-0.3 0-0.7 0.1-1 0.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m15 7.3h-0.2c-0.2 0-0.4 0.1-0.6 0.1 0.3-0.1 0.5-0.1 0.8-0.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m30.4 29.6c-0.1 0.1-0.3 0.1-0.6 0.1l0.4 0.4c0.1-0.2 0.1-0.4 0.2-0.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "M8.5,18.1L8.3,18v11.1c0,0.3,0.1,0.6,0.2,0.9l1.6-1.5v-9.1L8.5,18.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "M28.5,31.2c0.4,0,0.8-0.2,1.1-0.4l-1.2-1.2H11.7c-0.6,0-1,0-1.3-0.1l-1.3,1.3c0.3,0.3,0.7,0.4,1.1,0.4H28.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1HK",
    d: "m28.5 31.9h-18.3-0.5c0.2 0.1 0.5 0.1 0.8 0.1h17.8c0.1 0 0.3-0.1 0.4-0.1h-0.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m24.2 12.1h-1.1c-0.7 0-1.2-0.7-1.2-1.5v-1.4c0-0.1 0-0.2-0.1-0.2-0.1-0.1-0.1-0.1-0.2-0.1-0.2 0-0.3 0.2-0.3 0.4v1.3c0 0.6 0.2 1.2 0.5 1.6s0.8 0.7 1.3 0.7h1c0.1 0 0.3-0.2 0.3-0.4s-0.1-0.4-0.2-0.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryHK",
    d: "m31 16.6-4.4-3.7v1l3.6 3-4.2 3.5v-10.8c0-1.3-1-2.3-2.3-2.3h-8.7c-0.6 0-1.2 0.2-1.7 0.7-0.4 0.4-0.7 1-0.7 1.6v10.8l-4.2-3.5 3.6-3v-1l-4.3 3.6c-0.1 0.1-0.2 0.2-0.2 0.4v12.3c0 1.5 1.2 2.7 2.7 2.7h18.3c1.5 0 2.7-1.2 2.7-2.7v-12.3c0-0.1-0.1-0.2-0.2-0.3zm-17-8c0.3-0.3 0.7-0.4 1-0.4h8.6c0.8 0 1.5 0.7 1.5 1.5v11.5l-4.5 3.8c-0.7 0.6-1.7 0.6-2.4 0l-4.6-3.8v-11.5c-0.1-0.4 0.1-0.8 0.4-1.1zm16.4 20.6c0 0.3-0.1 0.6-0.2 0.9l-5.5-5.4c-0.2-0.2-0.4-0.2-0.6 0s-0.2 0.4 0 0.6l5.5 5.5c-0.3 0.2-0.7 0.4-1.1 0.4h-18.3c-0.4 0-0.8-0.1-1.1-0.4l5.5-5.5c0.1-0.2 0.1-0.4 0-0.5-0.2-0.1-0.4-0.1-0.6 0l-5.5 5.2c-0.1-0.3-0.2-0.6-0.2-0.9v-11.2l3.9 3.3 5.4 4.5c1 0.8 2.5 0.8 3.5 0l5.4-4.5 3.9-3.3v11.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.f7dcc2c97d3e2be669f3e7a21815684e.svg";
export { ForwardRef as ReactComponent };